function noEmpty(value) {
  return !!(value && value.length > 0);
}

export default noEmpty;
